export const energyInsightsStrings = {
  backToHub: 'Back to energy insights',
  productPageHeading: 'Energy insights',
  productDisplayName: 'OVO Energy tracker',
  productLegalName: 'OVO Energy Insights',
};
